import { useCallback, useEffect, useRef, useState } from 'react';
import ReCAPTCHABase from 'react-google-recaptcha';

import { Container, ErrorMessage } from './Recaptcha.style';
import { RecaptchaComponentProps } from './types';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const ReCAPTCHA = ReCAPTCHABase as any;

export const RecaptchaComponent = ({
  siteKey,
  triggerRevalidation,
  onChangeToken,
}: RecaptchaComponentProps) => {
  const recaptchaV2Ref = useRef<ReCAPTCHABase>(null);
  const onChangeTokenRef = useRef(onChangeToken);
  const [validationError, setValidationError] = useState<string | null>(null);

  useEffect(() => {
    onChangeTokenRef.current = onChangeToken;
  }, [onChangeToken]);

  const resetState = useCallback(() => {
    setValidationError(null);
  }, []);

  const reset = useCallback(() => {
    recaptchaV2Ref.current?.reset();
  }, [recaptchaV2Ref]);

  useEffect(() => {
    if (triggerRevalidation > 0) {
      setValidationError('ReCAPTCHA é obrigatório');
      onChangeTokenRef.current(null);
      reset();
    }
  }, [reset, triggerRevalidation]);

  return (
    <Container>
      <ReCAPTCHA
        ref={recaptchaV2Ref}
        sitekey={siteKey}
        onChange={(token: string | null) => {
          resetState();
          onChangeToken(token);
        }}
      />
      {validationError && (
        <ErrorMessage
          data-testid='recaptcha-error'
          className='animate__animated animate__bounceInRight'
        >
          {validationError}
        </ErrorMessage>
      )}
    </Container>
  );
};
